import { css } from 'emotion'

export const MemberMainStyles = css`
  .ActionButton {
    &.danger {
      margin-left: 16px;
    }
  }
`
